import React, { useState } from 'react';
import {
  Box,
  Container,
  Heading,
  Text,
  VStack,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';

const MotionBox = motion(Box);

/**
 * Workshop FAQ Section
 * Displays frequently asked questions and answers
 */
const WorkshopFAQ = ({ workshop }) => {
  if (!workshop?.faq || workshop.faq.length === 0) return null;

  const { faq } = workshop;

  return (
    <Box py={{ base: 16, md: 20 }} bg="white">
      <Container maxW="container.lg">
        {/* Header */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          mb={{ base: 12, md: 16 }}
        >
          <VStack align="center" spacing={3} textAlign="center">
            <Heading as="h2" size="xl" fontWeight="900" color="gray.900">
              Frequently Asked Questions
            </Heading>
            <Text fontSize="lg" color="gray.600" maxW="2xl">
              Everything you need to know about the workshop
            </Text>
          </VStack>
        </MotionBox>

        {/* FAQ Accordion */}
        <MotionBox
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          maxW="2xl"
          mx="auto"
        >
          <Accordion allowToggle>
            {faq.map((item, idx) => (
              <AccordionItem key={idx} borderColor="gray.200">
                <AccordionButton
                  py={4}
                  _hover={{ bg: 'gray.50' }}
                  _expanded={{ bg: 'purple.50', color: 'purple.600' }}
                >
                  <Text
                    flex={1}
                    textAlign="left"
                    fontWeight="bold"
                    fontSize="md"
                  >
                    {item.question}
                  </Text>
                  <AccordionIcon />
                </AccordionButton>

                <AccordionPanel pb={4} pt={2}>
                  <Text color="gray.700" lineHeight="1.8">
                    {item.answer}
                  </Text>
                </AccordionPanel>
              </AccordionItem>
            ))}
          </Accordion>
        </MotionBox>

        {/* Contact CTA */}
        <Box
          mt={12}
          p={6}
          bg="purple.50"
          borderRadius="lg"
          textAlign="center"
          borderLeft="4px solid"
          borderColor="purple.600"
        >
          <Text color="gray.800" mb={2}>
            Didn't find your answer?
          </Text>
          <Text
            as="a"
            href="/contact"
            color="purple.600"
            fontWeight="bold"
            _hover={{ textDecoration: 'underline' }}
          >
            Get in touch with us →
          </Text>
        </Box>
      </Container>
    </Box>
  );
};

export default WorkshopFAQ;
